/**
 * 오브젝트 형태의 객체를 받아서 Map으로 형변환해주는 함수
 * @param param 객체
 * @returns {Map<string, unknown>}
 */
export function toMap(param){
    return new Map(Object.entries(param));
}